class CardProduit {
  constructor() {
    this._init();
  }

  private _init(): void {
    document.addEventListener('DOMContentLoaded', () => {
      this._bindPopinEvents();
    });
  }

  private _bindPopinEvents(): void {
    document.addEventListener('click', (event: MouseEvent) => {
      const openBtn = (event.target as HTMLElement).closest('.js-open-buy-popin') as HTMLButtonElement | null;
      if (openBtn) {
        event.preventDefault();
        const targetSelector = openBtn.dataset.target;
        if (targetSelector) {
          const dialog = document.querySelector(targetSelector) as HTMLDialogElement | null;
          if (dialog) {
            this._injectHiddenFields(
              dialog,
              openBtn.dataset.productId,
              openBtn.dataset.productTitle,
              openBtn.dataset.productEditLink,
              openBtn.dataset.productFormType
            );
            if (typeof dialog.showModal === 'function') {
              dialog.showModal();
            } else {
              dialog.setAttribute('open', 'true');
            }
          }
        }
        return;
      }

      const closeBtn = (event.target as HTMLElement).closest('.js-close-buy-popin') as HTMLButtonElement | null;
      if (closeBtn) {
        event.preventDefault();
        const dialog = closeBtn.closest('dialog') as HTMLDialogElement | null;
        if (dialog) {
          this._closeDialog(dialog);
        }
        return;
      }

      const targetElement = event.target as HTMLElement;
      if (targetElement.tagName === 'DIALOG' && targetElement.classList.contains('buy-popin')) {
        const dialog = targetElement as HTMLDialogElement;
        const rect = dialog.getBoundingClientRect();
        const isInDialog = (
          rect.top <= event.clientY &&
          event.clientY <= rect.bottom &&
          rect.left <= event.clientX &&
          event.clientX <= rect.right
        );
        if (!isInDialog) {
          this._closeDialog(dialog);
        }
      }
    });
  }

  private _injectHiddenFields(
    dialog: HTMLDialogElement,
    productId?: string,
    productTitle?: string,
    productEditLink?: string,
    productFormType?: string
  ): void {
    const form = dialog.querySelector('form');
    if (!form) return;

    if (productId) {
      let inputId = form.querySelector<HTMLInputElement>('input[name="produit_id"]');
      if (!inputId) {
        inputId = document.createElement('input');
        inputId.type = 'hidden';
        inputId.name = 'produit_id';
        form.appendChild(inputId);
      }
      inputId.value = productId;
    }

    if (productTitle) {
      let inputTitle = form.querySelector<HTMLInputElement>('input[name="produit_title"]');
      if (!inputTitle) {
        inputTitle = document.createElement('input');
        inputTitle.type = 'hidden';
        inputTitle.name = 'produit_title';
        form.appendChild(inputTitle);
      }
      inputTitle.value = productTitle;
    }

    if (productEditLink) {
      let inputEditLink = form.querySelector<HTMLInputElement>('input[name="produit_edit_link"]');
      if (!inputEditLink) {
        inputEditLink = document.createElement('input');
        inputEditLink.type = 'hidden';
        inputEditLink.name = 'produit_edit_link';
        form.appendChild(inputEditLink);
      }
      inputEditLink.value = productEditLink;
    }

    if (productFormType) {
      let inputFormType = form.querySelector<HTMLInputElement>('input[name="produit_form_type"]');
      if (!inputFormType) {
        inputFormType = document.createElement('input');
        inputFormType.type = 'hidden';
        inputFormType.name = 'produit_form_type';
        form.appendChild(inputFormType);
      }
      inputFormType.value = productFormType;
    }
  }

  private _closeDialog(dialog: HTMLDialogElement): void {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

}

export const cardProduit = new CardProduit();
